import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { IDataPesquisarAspectosCafe } from "../../types/api/cafe/pesquisar-aspectos-cafe";
import { onChangeMultipleValue } from "./helpers";

export default function SelectAspectoCafe({
    value,
    onChange,
    type = "single"
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-aspectos-cafe"],
        queryFn: () => axiosClient.get("pesquisar-aspectos-cafe", {
            params: {
                limit: 50
            }
        })
    });
    const listData: IDataPesquisarAspectosCafe[] = data?.data.data || []
    //

    if (type === "single") return (
        <Autocomplete
            disablePortal
            disabled={isLoading}
            id="combo-box-demo"
            value={value as SingleValue}
            options={listData.map((i) => ({ label: i.aspecto_nome, id: i.aspecto_id }))}
            onChange={(_: any, newValue: TObjValue | null) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Aspecto"} fullWidth />}
        />
    )

    //type == multiple
    const valorFormatado = (value as TObjValue[]).map((item) => `${item.id},${item.label}`)

    const handleChangeMultipleValue = (event: SelectChangeEvent<string[]>) => {
        const valorFinal = onChangeMultipleValue(event.target.value as string[])
        onChange(valorFinal as MultipleValue)
    }
    //

    return (
        <FormControl fullWidth>
            <InputLabel id="aspecto-cafe">{isLoading ? "Carregando" : "Aspecto"}</InputLabel>
            <Select
                labelId="aspecto-cafe"
                id="demo-multiple-name"
                multiple
                disabled={isLoading}
                value={valorFormatado}
                onChange={handleChangeMultipleValue}
                input={<OutlinedInput label="Aspecto" />}
                renderValue={(selected) => selected.map(e => e.split(",")[1]).join(', ')}
            >
                <MenuItem value="NaN,Todos(as)">
                    <Checkbox checked={valorFormatado.indexOf("NaN,Todos(as)") > -1} />
                    Todos(as)
                </MenuItem>

                {[...listData].map((item) => {
                    const valorOption = `${item.aspecto_id},${item.aspecto_nome}`
                    return (
                        <MenuItem
                            key={item.aspecto_id}
                            value={valorOption}
                        >
                            <Checkbox checked={valorFormatado.indexOf(valorOption) > -1} />
                            {item.aspecto_nome}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    type?: 'single' | 'multiple';
    value: SelectValue;
    onChange: (arg: SelectValue) => void;
}

type SelectValue = SingleValue | MultipleValue;

type SingleValue = TObjValue | null;
type MultipleValue = TObjValue[];

type TObjValue = { label: string, id: number }